import React, { Fragment, useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import notepadIcon from '../../../../../../assets/svg/notepad.svg';
import Skeleton from '@material-ui/lab/Skeleton';
import { store } from './Customer';
import { store as mainStore } from '../../../../../../store';
import lime from '@material-ui/core/colors/lime';
import orange from '@material-ui/core/colors/orange';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import IconButton from '@material-ui/core/IconButton';
import { __ } from '../../../../../../utils/i18n';
import moment from 'moment-jalaali';

const useStyles = makeStyles((theme) => ({
  noteContainer: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& > div:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  notes: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    '& > div': {
      background: lime['A100'],
      padding: theme.spacing(2),
      textAlign: 'justify',
      height: 100,
      width: 200,
      marginBottom: theme.spacing(1),
      overflowY: 'auto',
    },
    '&> div:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  note: {
    position: 'relative',
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > span': {
      color: orange[400],
    },
    '&>div': {
      display: 'none',
    },
    '&:hover>div': {
      display: 'block',
    },
  },
  noteFooter: {
    color: 'gray',
    size: 10,
  },
  deleteButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

const Notes = () => {
  const classes = useStyles();
  const {
    state: { notes, deleteNote },
    dispatch,
  } = useContext(store);
  const { showMessage, showError } = useContext(mainStore);
  const [loadingDeletingNote, setLoadingDeletingNote] = useState({
    id: '',
    loading: false,
  });

  const handleDeleteNote = async (id) => {
    try {
      setLoadingDeletingNote({ id: id, loading: true });
      const response = await deleteNote(id);
      showMessage(response.messages);
      dispatch({ type: 'NOTES', payload: response.notes });
    } catch (error) {
      showError(error);
    } finally {
      setLoadingDeletingNote({ id: id, loading: false });
    }
  };

  return (
    <div className={classes.noteContainer}>
      {notes ? (
        notes.length ? (
          <div className={classes.notes}>
            {notes.map((n, i) => (
              <div className={classes.note} key={n._id}>
                <Fragment>
                  <div className={classes.deleteButton}>
                    <IconButton
                      disabled={
                        n._id === loadingDeletingNote.id &&
                        loadingDeletingNote.loading
                      }
                      onClick={() => handleDeleteNote(n._id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                  <span>یادداشت:</span>
                  {n.log.note}
                  <div className={classes.noteFooter}>
                    {`توسط: ${__(n.creator.role[0])}`}
                    <br />
                    {`${n.creator.firstName} ${n.creator.lastName}`}
                    <br />
                    {moment(n.createdAt).format('jYYYY/jMM/jDD - HH:mm')}
                  </div>
                </Fragment>
              </div>
            ))}
          </div>
        ) : (
          <Fragment>
            <div>
              <img
                src={notepadIcon}
                alt="یادداشت های این کاربر"
                height={150}
                width={150}
              />
            </div>
            <div
              style={{
                maxWidth: 350,
                textAlign: 'center',
                fontSize: 12,
                color: '#ccc',
              }}
            >
              هنوز یادداشتی برای این کاربر ثبت نشده.
            </div>
          </Fragment>
        )
      ) : (
        <Skeleton variant="rect" height={200} animation="wave" />
      )}
    </div>
  );
};

export default Notes;
